import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { isBlank, notBlank } from "../../util/ext";
import { useOrganizationPropertyKeyValues } from "../organizationServices";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";

const filter = createFilterOptions();

const PropertyValueComboBox = ({
  propKey,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  label,
  placeholder,
}) => {
  const [propertyValues, setPropertyValues] = useState([]);

  const valuesResponse = useOrganizationPropertyKeyValues(propKey);
  useEffect(() => {
    if (valuesResponse.isSuccess && notBlank(valuesResponse.data)) {
      setPropertyValues(valuesResponse.data);
    }
  }, [propKey, valuesResponse.isSuccess, valuesResponse.data]);

  const handleChange = (_event, value) => {
    const val =
      notBlank(value) && notBlank(value.inputValue) ? value.inputValue : value;

    const changeVal =
      notBlank(val) && val.toLowerCase() === "true"
        ? "1"
        : notBlank(val) && val.toLowerCase() === "false"
        ? "0"
        : val;

    onChange(changeVal);
  };

  const [inputValue, setInputValue] = useState("");
  const handleKeyDown = event => {
    if (event.key === "Tab" && inputValue.length > 0) {
      handleChange(event, inputValue);
    }
  };

  return (
    <Autocomplete
      freeSolo
      handleHomeEndKeys
      id="property-value"
      options={propertyValues}
      disabled={isBlank(propKey)}
      value={value}
      onChange={handleChange}
      inputValue={inputValue}
      onInputChange={(_event, val) => setInputValue(val)}
      getOptionLabel={option =>
        option.inputValue
          ? option.inputValue
          : option === "0"
          ? "false"
          : option === "1"
          ? "true"
          : option
      }
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        // Suggest the creation of a new value
        if (notBlank(params.inputValue)) {
          filtered.push(params.inputValue);
        }

        return filtered;
      }}
      renderInput={params => {
        params.inputProps.onKeyDown = handleKeyDown;
        return (
          <TextField
            {...params}
            variant="standard"
            label={label || "Property Value"}
            placeholder={placeholder || "Select or Enter New Value..."}
            onBlur={onBlur}
            error={error}
            helperText={helperText}
          />
        );
      }}
    />
  );
};

export default PropertyValueComboBox;
